import * as rocketNoData01 from "./images/rocket-no-data/rocket-01.svg";
import * as rocketNoData02 from "./images/rocket-no-data/rocket-02.svg";

export { rocketNoData01, rocketNoData02 };
